export enum TipoPauta {
  Normal = 'NORMAL',
  Eleicao = 'ELEICAO',
  Coordenador = 'COORDENADOR'
}
